import { BitkitAlert } from '@bitrise/bitkit-v2';

import useTestQuarantineList from '@/client/BFF/App/TestQuarantine/useTestQuarantineList';
import { projectTestQuarantinePage } from '@/utils/monolithApiRouteService';

const TestQuarantineAlert = ({ projectSlug }: { projectSlug: string }) => {
  const { data, isPending } = useTestQuarantineList(projectSlug);

  if (isPending || !data || data.testCases.length === 0) {
    return null;
  }

  return (
    <BitkitAlert
      action={{
        href: projectTestQuarantinePage(projectSlug),
        label: 'Open quarantined tests',
        target: '_blank',
      }}
      marginBlock="16"
      variant="info"
      titleText="Can't find a test?"
      messageText={
        <>
          It might be quarantined. Quarantined tests don&apos;t run and won&apos;t appear in this report. Review the
          list of quarantined tests.
        </>
      }
    />
  );
};

export default TestQuarantineAlert;
